// extracted by mini-css-extract-plugin
export default {"form":"Form_form__MCyoe","input":"Form_input__Ze0Xa","button":"Form_button__NkLWz","title":"Form_title__76173","error":"Form_error__Gh8r+","otherForm":"Form_otherForm__be+Wn"};